const search = {
    busy: false,
    type: 'post',
    keyword: '',
    users: [],
    hasMore: true,
    total: 0
};

export default search;